export const getActivityMode = (mode) => {
	return mode ? 'visible' : 'hidden';
};
